export const STAGES = ["idea", "script", "filming", "editing", "review", "ready", "scheduled", "published"];
export const TYPES = ["long", "short"];

export const formatEST = (isoString) => {
  if (!isoString) return "";
  try {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      timeZone: "America/New_York",
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return "";
  }
};
